import { csx } from '@vtex/admin-ui'

export const styles = {
  card: {
    container: csx({
      marginTop: '$space-10',
      '> :not(.card-item:last-of-type)': {
        borderBottom: '$neutral',
      },
    }),
  },
}
